export default {
    //Splash
    splash_message: 'Платформа для общения и обучения',

    //TTCC
    accept_ttcc: 'Принять условия использования',

    //Login
    welcome: 'Добро пожаловать!',
    welcome_message: 'dots, ваш новый технологический партнер для общения и обучения.',
    username: 'Имя пользователя',
    password: 'Пароль',
    code: 'Код',
    recover_password: 'Восстановить пароль',
    log_in: 'Войти',
    log_in_biometrics: 'Вход с биометрическими данными',
    create_user: 'Создать пользователя',
    recover_access_to_account: 'Введите ваше имя пользователя, чтобы восстановить доступ к аккаунту',
    back: 'Назад',
    enter_new_password: 'Введите ваш код и новый пароль',
    enter_code: 'Введите код',
    new_password: 'Новый пароль',
    repeat_new_password: 'Повторите новый пароль',
    validate: 'Подтвердить',
    complete_all_fields: 'Заполните все поля',
    passwords_do_not_match: 'Пароли не совпадают',
    user_created_successfully: 'Пользователь успешно создан',
    create_user: 'Создать пользователя',
    required_fields: 'Обязательные поля',
    confirm_your_email: 'Подтвердите вашу электронную почту',
    confirm_your_phone: 'Подтвердите ваш телефон',
    confirm_password: 'Подтвердите пароль',
    modifying_email: 'Вы изменяете свою электронную почту',
    validate_code: 'Подтвердите код',
    code_sent_successfully: 'Код успешно отправлен',
    password_reset: 'Ваш пароль успешно сброшен',
    enter_confirmation_code: 'Введите ваш код подтверждения',
    enter_your_new_email: 'Введите ваш новый адрес электронной почты',
    //nuevos al 01-08-2024
    user_does_not_exist: 'Ой! Мы не смогли найти ваш аккаунт',
    contact_the_administrator:
        'Похоже, что пользователь, которого вы ввели, не существует.\nПроверьте правильность написания\nили свяжитесь с администратором.',
    invalid_user_or_pass: 'Неверное имя пользователя и/или пароль',
    info_is_not_correct: 'Некоторая информация неверна, пожалуйста, попробуйте снова.',
    enter_user: 'Пожалуйста, введите имя пользователя',
    nonexistent_user: 'Несуществующий пользователь. Пожалуйста, попробуйте снова.',
    incorrect_code: 'Неверный код',
    change_saved_successfully: 'Изменение успешно сохранено',
    pass_changed_successfully: 'Пароль успешно изменен',
    check_your_email: 'Проверьте свою электронную почту для ввода кода подтверждения',
    eight_characters: '*Должно содержать более 8 символов',
    one_uppercase_letter: '*Должно содержать хотя бы одну заглавную букву',
    one_special_character: '*Должно содержать хотя бы один специальный символ (@,$,!,#,?)',
    pass_requirements:
        'Вы должны соответствовать следующим требованиям:\n\n*Должно содержать более 8 символов\n*Должно содержать хотя бы одну заглавную букву\n*Должно содержать хотя бы один специальный символ (например: $, !, #, ?)',
    select_date: 'Выберите дату',
    cannot_create_password: 'Не удается создать пароль',
    complete_your_details: 'Заполните свои данные для продолжения',
    validate_code: 'Подтвердите код',
    enter_valid_number: 'Вы должны ввести действительный номер',
    complete_numbers:
        'Префикс "15" должен быть удален, чтобы окончательное число содержало 13 цифр, пример: +54 9 XXX XXX XXXX, вы должны заполнить оставшиеся 10 цифр.',

    //Profile
    insufficient_permissions: 'Недостаточно прав',
    permissions_are_required: 'Необходимы права для доступа к камере и галерее.',
    choose_font: 'Выберите источник',
    where_do_you_want: 'Откуда вы хотите выбрать изображение?',
    camera: 'Камера',
    gallery: 'Галерея',
    edit_photo: 'Редактировать фото',
    cancel: 'Отмена',
    save: 'Сохранить',
    app: 'Приложение',
    support: 'Поддержка',
    other: 'Другое',
    contact_channel: 'Канал связи',
    select_the_contact_channel: 'Выберите канал связи',
    subject: 'Тема',
    write_the_subject: 'Напишите тему',
    message: 'Сообщение',
    write_a_comment: 'Напишите комментарий',
    send: 'Отправить',
    sent_successfully: 'Успешно отправлено',
    thank_you_for_leaving_us_your_comments: 'Спасибо за ваш комментарий, мы свяжемся с вами в ближайшее время.',
    close: 'Закрыть',
    check_for_update: 'Проверить обновление',
    clear_cache: 'Очистить кэш',
    delete_account: 'Удалить аккаунт',
    log_out: 'Выйти',
    notifications: 'Уведомления',
    insufficient_permissions: 'Недостаточно прав',
    permissions_to_access: 'Необходимы права для доступа к камере и галерее.',
    choose_font: 'Выберите источник',
    select_the_image: 'Откуда вы хотите выбрать изображение?',
    change_language: 'Изменить язык',
    change_language_title: 'Важный!',
    change_language_message:
        'Для выполнения этого действия необходимо наличие подключения к Интернету. При этом будет удален контент, загруженный для автономного использования. Обратите внимание, что изменение повлияет только на содержимое приложения, а не на его структуру, которая зависит от языка вашего устройства.',
    logout_not_available: 'Выход недоступен',
    cant_logout:
        'Вы не можете выйти из системы сейчас, так как у вас нет подключения к интернету. Пожалуйста, проверьте ваше подключение и попробуйте снова.',
    //nuevos al 01-08-2024
    cache_cleared: 'Кэш успешно очищен',
    deletes_the_content:
        'Это действие удаляет контент, загруженный для использования приложения в автономном режиме. Убедитесь, что вы подключены, чтобы продолжить просмотр.',
    error_uploading_image: 'Ошибка при загрузке изображения: ',
    there_was_an_error: 'Произошла ошибка при загрузке изображения. Пожалуйста, попробуйте еще раз.',
    //nuevos al 21-11-2024
    email: 'Электронная почта',
    phone: 'Телефон',
    name: 'Имя',
    last_name: 'Фамилия',
    role: 'Роль',
    verify: 'Подтвердить',
    verified: 'Подтверждено',
    contact_channels: 'Каналы связи',
    editing_your_email: 'Вы редактируете свой электронный адрес',
    editing_your_phone: 'Вы редактируете свой номер телефона',
    modifying_your_email:
        'Вы изменяете свой электронный адрес, вам будет отправлен код на ваш email для ввода. Если вы еще не получили код, пожалуйста, проверьте снова.',
    modifying_your_phone:
        'Вы изменяете номер своего мобильного телефона, вам будет отправлен SMS код для ввода. Если вы еще не получили код, пожалуйста, проверьте снова.',

    //Notifications
    all: 'Все',
    unread: 'Непрочитанные',
    read: 'Прочитанные',
    seen: 'Просмотрено',
    notifications: 'Уведомления',
    here_you_will_find: 'Здесь вы найдете все предупреждения и уведомления!',
    mark_all_read: 'Отметить все как прочитанные',
    you_have_no_notifications: 'У вас нет уведомлений!',
    you_will_soon_start: 'Вы скоро начнете получать новые уведомления',

    //Buscador
    enter_your_search: 'Введите ваш запрос',
    no_results: 'Нет результатов',
    search_content: 'Ищите контент, который вас интересует.',
    see: 'Смотреть',
    results_in: 'результатов в',
    see_less_results: 'Смотреть меньше результатов',
    all: 'Все',
    wall: 'Стена',
    learning: 'Обучение',
    benefits: 'Преимущества',
    portfolio: 'Портфолио',
    retry: 'Повторить',
    locked: 'Заблокировано',
    pending: 'В ожидании',
    seen: 'Просмотрено',
    approved: 'Одобрено',

    //Posts
    see_them: 'Смотреть все',
    _comments: ' комментарии',
    reactions_from_other_users: 'Реакции других пользователей',
    not_connected_to_the_network: 'Не подключено к сети',
    comment: 'Комментарий',
    comments: 'Комментарии',
    write_a_comment: 'Написать комментарий',
    no_content: 'Нет контента',
    not_connected_to_the_network: 'Вы не подключены к сети',
    reaction: 'Реакция',
    reactions: 'Реакции',
    first_comment: 'Оставьте первый комментарий!',
    no_comment: 'К этому посту еще нет комментариев.',
    write_a_comment: 'Написать комментарий',
    no_publications: 'Нет публикаций',
    no_post_to_read: 'У вас нет постов для чтения.',
    views: 'просмотры',
    reply: 'Ответить',
    see: 'Смотреть',
    more_answers: 'больше ответов',
    hide: 'Скрыть',
    answers: ' ответы',
    no_reactions: 'Еще нет реакций!',
    leave_your_reaction: 'Будьте первым, кто оставит реакцию.',
    //nuevos al 01-08-2024
    full_survey: 'Вы завершили опрос!',
    thanks_for_participating: 'Спасибо за участие! Следите за стеной, чтобы быть в курсе новостей.',
    sent_automatically: 'Он будет отправлен автоматически, когда вы восстановите соединение.',
    no_post_saved: 'Пока нет сохраненных публикаций',
    see_your_favorite_content: 'Здесь вы увидите свой любимый контент.',
    //fechas
    instant: 'Только что',
    hourFirst: ' назад',
    hour: ' час',
    hours: ' часов',
    day: ' день',
    days: ' дней',

    //Learning
    congratulations: 'Поздравляем!',
    you_approved: 'Вы прошли',
    you_completed: 'Вы завершили этот курс',
    you_disapproved: 'Оценка не прошла',
    score: 'Оценка:',
    return_to_course: 'Вернуться к курсу',
    retry: 'Повторить',
    it_is_available: 'Теперь доступно',
    total_course_evaluation: 'Итоговая оценка курса',
    evaluate_me: 'ОЦЕНИТЕ МЕНЯ',
    completed_the_course: 'Вы завершили курс',
    pending_approval: 'Ожидает одобрения',
    return: 'Вернуться',
    continue_course: 'Продолжить курс',
    you_have_made: 'Вы завершили',
    of_the_course: ' курса',
    locked: 'заблокировано',
    pending: 'в ожидании',
    seen: 'просмотрено',
    complete: 'завершено',
    reprobate: 'не сдано',
    sync_pend: 'в ожидании синхронизации',
    in_progress: 'в процессе',
    perform_evaluation: 'Выполнить оценку',
    next_content: 'Следующий контент',
    you_completed_all: 'Вы завершили весь контент',
    final_evaluation: 'ЗАКЛЮЧИТЕЛЬНАЯ ОЦЕНКА',
    retry_mayus: 'ПОВТОРИТЬ',
    see_more: '...больше',
    see_less: '...меньше',
    back_to_course: 'ВЕРНУТЬСЯ К КУРСУ',
    click_to_see: 'Нажмите, чтобы посмотреть',
    //Evaluaciones
    evaluation: 'Оценка: ',
    of: ' из ',
    loading_evaluation: 'Загрузка оценки...',
    select_option: 'Выберите опцию, чтобы продолжить',
    select_one_answer: 'Выберите как минимум один ответ на каждый вопрос.',
    exit_evaluation: 'Вы хотите выйти из оценки?',
    your_answers_will_not_be_saved: 'Если вы уйдете сейчас, ваши ответы не сохранятся.',
    continue_evaluation: 'Продолжить оценку',
    leave_anyway: 'Выйти в любом случае',
    try_again: 'Попробовать снова!',
    passed_the_evaluation: 'Вы прошли оценку',
    start_the_course_again: 'Вы не завершили оценку. Начните курс заново.',
    evaluation_pending_approval: 'Оценка в ожидании',
    notification_result_evaluation: 'Вы будете уведомлены о результатах вашей оценки в ближайшее время',
    write_here: 'Напишите здесь...',
    close: 'Закрыть',
    confirm: 'Подтвердить',
    sync_pending: 'В ожидании синхронизации',
    view_certificate: 'Посмотреть сертификат',

    // nuevos al 27-01-2025
    course_download_in_process: 'Загрузка курса в процессе',
    course_is_downloading:
        'Пожалуйста, подождите несколько секунд. Курс загружается, чтобы вы могли получить доступ ко всему контенту офлайн без проблем.',
    downloaded_course: 'Курс успешно загружен',
    you_can_train_offline: 'Готово! Теперь вы можете тренироваться офлайн.',
    delete_offline_course: 'Вы хотите удалить этот курс из офлайн-режима?',
    not_view_course_offline: 'Вы не сможете просматривать этот курс в офлайн-режиме.',
    course_is_not_available: 'Курс больше не доступен...',
    not_available_offline: 'Курс больше не доступен офлайн, но вы можете загрузить его снова, когда потребуется.',
    content_download_in_process: 'Загрузка контента в процессе',
    content_is_downloading: 'Пожалуйста, подождите несколько секунд. Контент загружается, чтобы вы могли получить к нему доступ офлайн без проблем.',
    downloaded_content: 'Контент успешно загружен',
    delete_offline_content: 'Вы хотите удалить офлайн-контент?',
    not_view_content_offline: 'После удаления вы не сможете получить доступ к контенту в офлайн-режиме.',
    content_is_not_available: 'Контент больше не доступен...',
    download_offline: 'Загрузить офлайн',
    available_offline: 'Доступно офлайн',
    delete: 'Удалить',
    //Stores
    your_progress_in_stores: 'Ваш прогресс в магазинах',
    map: 'Карта',
    daily_survey: 'Ежедневный опрос',
    survey: 'Опрос',
    matutino: 'Утро',
    vespertino: 'Вечер',
    form: 'Форма',
    enter_a_number: 'Введите номер',
    campaign_expiration: 'КОНЕЦ КАМПАНИИ: ',
    store_indicators: 'Показатели магазина',
    last_days: 'Последние 30 дней',
    main_indicators: 'Узнайте основные показатели вашего магазина',
    store_information: 'Получите полную информацию о вашем магазине',
    perform_executions: 'Выполните следующие задачи, чтобы узнать статус вашего магазина',
    pending_mayus: 'ОЖИДАЕТСЯ',
    approved_mayus: 'ОДОБРЕНО',
    in_review_mayus: 'НА РАССМОТРЕНИИ',
    redo_mayus: 'ПОВТОРИТЬ',
    visited_mayus: 'ПОСЕЩЕНО',
    visited_mayus_sync: 'ПОСЕЩЕНО SYNC',
    visited_store_mayus: 'ПОСЕЩЕННЫЕ МАГАЗИНЫ',
    checkin_realized_sync: 'ПОСЕЩЕННЫЕ МАГАЗИНЫ SYNC',
    moderation_mayus: 'МОДЕРАЦИЯ',
    review_mayus: 'ОБЗОР',
    in_progress_mayus: 'В ПРОЦЕССЕ',
    complete: 'Завершено',
    sync_pend: 'В ожидании синхронизации',
    locked_mayus: 'ЗАБЛОКИРОВАНО',
    complete_mayus: 'ПОЛНЫЙ',
    perfect_store: 'Идеальный магазин',
    execution: 'Выполнение',
    vouchers: 'Ваучеры',
    send: 'Отправить',
    requires: 'Требуется ',
    variation: 'Вариация',
    validity: 'Действителен до: ',
    points: 'баллы',
    voucher_canceled: 'Ваучер отменен',
    you_can_try_again: 'Не волнуйтесь! Попробуйте снова.',
    voucher_successful: 'Ваучер успешно выполнен',
    successful_promo: 'Промо успешно!',
    voucher_pending: 'Ваучер в ожидании',
    wait_for_the_validation: 'Ожидайте проверки ваучера',
    your_code_is_being_scanned: 'Ваш код сканируется ⏳',
    view_qr: 'Посмотреть QR',
    return_to_store: 'Вернуться в магазин',
    stores_objective: 'Вы должны выполнить цель магазина.',
    welcome_stores: 'Добро пожаловать в магазин!',
    tip_day: 'Здесь вы можете посмотреть ваш ежедневный магазин, заполнить необходимые опросы и отслеживать ваш прогресс.',
    close_mayus: 'ЗАКРЫТЬ',
    select_form: 'Выберите форму для начала',
    select_one_form: 'Вы должны выбрать одну форму для начала опроса.',
    answer_all_questions: 'Вы должны ответить на все вопросы, чтобы продолжить.',
    schedule_not_found: 'Расписание на сегодня не найдено.',
    form_not_found: 'Форма в расписании не найдена.',
    send: 'Отправить',
    check_in: 'Регистрация',
    check_out: 'Выезд',
    check_out_done: 'Выезд успешно завершен',
    off_route: 'Вы вышли с маршрута, нажмите здесь, чтобы вернуться к расписанию',
    search_barcode: 'Поиск по штрих-коду',
    no_agenda_today: 'Сегодня у вас нет расписания!',
    no_agenda_week: 'На этой неделе у вас нет расписания!',
    no_information_today: 'На сегодня у вас нет расписания, свяжитесь с вашим руководителем, если у вас есть вопросы.',
    no_information_week: 'Информация для пользователя не найдена, свяжитесь с вашим руководителем, если у вас есть вопросы.',
    //nuevos al 01-08-2024
    not_have_camera_permissions: 'У вас нет разрешений на камеру',
    activate_from_settings: 'Активируйте это в настройках вашего устройства, чтобы продолжить.',
    modify_permissions: 'Изменить разрешения',
    complete_fields: 'Заполните следующие поля для создания магазина',
    create: 'Создать',
    store_name: 'Название магазина',
    enter_store_name: 'Введите название магазина',
    sore_address: 'Адрес',
    enter_sore_address: 'Введите адрес магазина',
    cluster: 'Кластер',
    store_phone: 'Телефон',
    enter_sore_phone: 'Введите телефон магазина',
    activate_survey: 'Чтобы активировать опрос 1.1 Vespertino, вам нужно выполнить цели по магазинам. Цели: ',
    inactive_vespertino: 'Vespertino неактивен',
    active_vespertino: 'Vespertino активен',
    completed_your_mandatory_objectives: 'Вы выполнили свои обязательные цели на день, теперь вы можете провести Vespertino.',
    complete_now: 'Завершить сейчас',
    perform_later: 'Выполнить позже',
    back_to_your_agenda: 'Хотите вернуться к вашему дневному расписанию?',
    return_to_the_current_day: 'Вы просматриваете активности предыдущих дней, если нажмете продолжить, вы вернетесь к текущему дню: ',
    continue: 'Продолжить',
    reached_your_goal: 'Вы достигли своей цели!',
    search_by_barcode: 'Поиск по штрих-коду',
    scan_the_barcode: 'Сканируйте штрих-код любого продукта\nв списке этого опроса.',
    return_to_form: 'Вернуться к форме',
    product_not_found: 'Продукт не найден',
    code_does_not_match: 'Код не совпадает ни с одним продуктом, связанным с этой формой.',
    search_another_product: 'Найти другой продукт',
    form_submitted_successfully: ' был успешным!',
    send_new_survey: 'Если хотите, вы можете отправить новый опрос.',
    no_agenda_for_today: 'На сегодня нет повестки дня!',
    consult_your_supervisor: 'У вас нет повестки дня на эту дату, по любым вопросам обращайтесь к вашему руководителю.',
    visiting_your_store: 'Вы посещаете свой магазин ',
    you_can_check_out: 'Вы можете выполнить выезд без завершения опроса: ',
    you_met_the_goal: 'Вы достигли цели, заполнять форму не требуется.',
    you_must_complete_the_survey: 'Для выполнения выезда вы должны завершить опрос: ',
    checkin_blocked: 'Регистрация заблокирована',
    close_the_open_checkin: 'Чтобы продолжить, вы должны закрыть открытую регистрацию.',
    close_the_checkin_opened_in: 'Чтобы продолжить, вы должны закрыть регистрацию, открытую в: ',
    checkin_out_of_range: 'Регистрация вне зоны доступа',
    more_meters_from_the_store: 'Вы находитесь более чем в 150 метрах от магазина.',
    now_is_your_turn: 'Теперь ваша очередь!',
    surveys_in_progress: 'У вас есть незавершенные опросы: ',
    unfinished_surveys: 'У вас есть незавершенные опросы: ',
    want_to_checkout: 'Вы уверены, что хотите выполнить выезд?',
    selected_store: 'Выбранный магазин',
    checkout_blocked: 'Выезд заблокирован',
    uncompleted_forms: 'У вас есть незавершенные формы!',
    checkout_anyway: 'Вы все равно хотите выполнить выезд?',
    go_to_survey: 'Перейти к опросу',
    take_the_survey: 'Теперь вы можете пройти опрос!',
    validity: 'Срок действия: ',
    search_store: 'Искать магазин...',
    no_results_for_your_search: 'Нет результатов по вашему запросу',
    find_another_store: 'Найдите другой магазин',
    //nuevos al 21-11-2024
    loading: 'Загрузка...',
    error_getting_data: 'Ошибка при получении данных.',
    no_information_to_display: 'Нет информации для отображения.',
    unzipping: 'Распаковка...',
    saving: 'Сохранение',
    loading_stores: 'Загрузка магазинов...',
    getting_stores: 'Получение магазинов...',
    request_has_failed: 'Достигнут максимальный количество попыток. Запрос не выполнен.',
    a_few_minutes: 'Загрузка магазинов...\nЭтот процесс может занять несколько минут.',
    //nuevos al 27-01-2025
    assets_download_completed: 'Загрузка ресурсов Perfect Store завершена',
    perfect_store_download: 'Загрузка фотографии успеха Perfect Store завершена',
    perfect_store_error: 'Ошибка при загрузке ресурсов Perfect Store',
    connection_interrupted: 'Соединение прервано, фотография успеха будет распакована после восстановления соединения',
    decompressing_perfect_store: 'Загрузка Perfect Store',
    downloading_perfect_store: 'Загрузка Perfect Store',
    saving_perfect_store: 'Сохранение Perfect Store',
    remain_downloaded: '\nОсталось загрузить ',
    assets: ' ресурсы.',
    download_complete: 'Загрузка завершена',

    //Portfolio
    no_brands_to_show: 'Нет брендов для показа',
    no_products_to_show: 'Нет продуктов для показа',
    try_again_later: 'Попробуйте снова позже',
    portfolio: 'Портфолио',
    select_one: 'Выберите один из наших брендов, чтобы увидеть продукты и услуги.',
    learn_about: 'Узнайте о всех продуктах и услугах в нашем приложении.',
    //nuevos al 01-08-2024
    brand: 'Бренд',
    description: 'Описание',
    ingredients: 'Ингредиенты',
    data_sheet: 'Технический лист',

    //Benefits
    points_can_be_exchanged: 'Баллы могут быть обменены на:',
    approved: 'Одобрено',
    cancelled: 'Отменено',
    pending: 'В ожидании',
    redeemed: 'ОБМЕНЯНО',
    added_points: 'БАЛЛЫ ДОБАВЛЕНЫ',
    all: 'Все',
    my_points: 'Мои баллы',
    your_points: 'Ваши баллы',
    delivered: 'Доставлено',
    no_benefits: 'Пока нет преимуществ',
    add_points: 'Получите баллы за взаимодействие и обменяйте',
    no_history: 'Пока нет истории',
    redeem_your_points: 'Обменивайте ваши баллы и смотрите историю преимуществ здесь',
    pending_approval: 'Ожидает одобрения',
    when_it_is_approved: 'После одобрения это появится в истории преимуществ',
    unredeemed_benefit: 'Необменянное преимущество',
    you_dont_have_enough_points: 'У вас недостаточно баллов для обмена на это преимущество',
    accept: 'Принять',
    units_available: ' доступные единицы',
    redeem_benefit: 'Обменять преимущество',
    benefits_mayus: 'ПРЕИМУЩЕСТВА',
    history: 'ИСТОРИЯ',
    there_was_a_mistake: 'Произошла ошибка',

    //Vouchers
    complete_to_redeem_the_voucher: 'Завершите, чтобы обменять ваучер',
    valid_until: 'Действителен до: ',
    quantity_purchased: 'Количество куплено: ',
    redeem: 'Обменять',
    lumps: 'Шишки',
    voucher_redeemed: 'Ваучер успешно обменян',
    error_redeeming_voucher: 'Произошла ошибка при обмене ваучера. Попробуйте снова.',
    validate_and_redeem_vouchers: 'Проверить и обменять ваучеры',
    to_get_started: 'Введите или сканируйте QR-код вашего ваучера, чтобы начать',
    write_your_code: 'Введите ваш код...',
    validate: 'Подтвердить',
    back_to_store: 'Вернуться в магазин',
    scan_qr: 'Сканируйте QR',
    scan_on_the_voucher: 'Чтобы начать, отсканируйте QR на ваучере',
    view_history: 'Просмотреть историю',
    voucher_history: 'История ваучеров',
    voucher_history_description:
        'Эта история позволяет вам точно отслеживать совершённые обмены, облегчая контроль и управление накопленными наградами.',
    see_more: 'Показать больше',
    see_less: 'Показать меньше',

    //Faltantes
    upload_image: 'Загрузить изображение',
    uploaded_image: 'Загруженное изображение',
    photo: 'Фото',
    edit: 'Редактировать',
    delete: 'Удалить',
    enter_a_comment: 'Введите комментарий',
    enter_a_value: 'Введите значение',
    want_to_check_out: 'Вы уверены, что хотите выйти?',
    not_check_in_again: 'После подтверждения вы не сможете зарегистрироваться снова до следующего визита.',

    //Alert
    alert: 'Предупреждение',
    enter_characters: 'Вы должны ввести 10 символов после префикса',
    numerical_field: 'Поле для редактирования должно быть числовым, без пробелов и букв.',
    enter_date_of_birth: 'Введите действительную дату рождения в формате ГГГГ-ММ-ДД.',
    session_expired: 'Сеанс истек',
    your_session_has_expired: 'Ваш сеанс истек. Пожалуйста, попробуйте снова.',
    error: 'Ошибка',
    error_occurred: 'Произошла ошибка при попытке изменить пароль.',
    email_verification_code_incorrect: 'Код подтверждения электронной почты неверен.',
    phone_verification_code_incorrect: 'Код подтверждения телефона неверен.',
    no_checkin_found: 'Чек-ин не найден.',

    //trivia
    your_position: 'Your position',
    play_again: 'Play again!',
    next: 'Next',
    position: 'Position',
    Questions: 'Question:',
    answer_right: 'The correct answer is:',
    game_completed_title1: 'Game completed!',
    game_completed_title2: 'Congratulations!',
    game_completed_title3: 'You finished the trivia.',
    game_completed_title4: 'Ready to see your results? Discover how many answers you got right and challenge yourself to improve your score.',
    game_unfinished_title1: 'Time is up for answering this or the questions.',
    game_unfinished_title2: "But don't worry, keep playing and show your knowledge in the next one!",
    tomorrow_again: 'New attempt tomorrow!',
    complete: 'Complete',
}
